import Spinner from '@/components/Spinner'

import { Button } from './styles'

interface DrawButtonProps {
  onClick: () => void
  isDisabled?: boolean
  isLoading?: boolean
}

export default function DrawButton({ onClick, isDisabled = false, isLoading = false }: DrawButtonProps) {
  return (
    <Button
      onClick={onClick}
      disabled={isDisabled || isLoading}
      aria-busy={isLoading || undefined}>
      {isLoading ? <Spinner size='small' color='#ffffff' /> : '쿠폰 찾기'}
    </Button>
  )
}
